<ng-container
  *ngComponentOutlet="
    components[config.variant].component;
    inputs: components[config.variant].inputs
  "
/>
